import script from "./Step1DatosPeleador.vue?vue&type=script&setup=true&lang=js"
export * from "./Step1DatosPeleador.vue?vue&type=script&setup=true&lang=js"

import "./Step1DatosPeleador.vue?vue&type=style&index=0&id=0f42f4ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f42f4ce"]])

export default __exports__